// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8d2fbba6","453":"33ea44f2","455":"87737ac9","977":"ffd49b10"}[chunkId] + ".chunk.js";
};